"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageButton = exports.PageButtonType = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var PageButtonType;
(function (PageButtonType) {
    PageButtonType["PREV"] = "<";
    PageButtonType["NEXT"] = ">";
    PageButtonType["ELLIPSIS"] = "...";
})(PageButtonType = exports.PageButtonType || (exports.PageButtonType = {}));
var PageButton = function (props) {
    var children = props.children, isActive = props.isActive, type = props.type, page = props.page, _a = props.onPageChange, onPageChange = _a === void 0 ? function () { return null; } : _a, _b = props.onEllipsisClick, onEllipsisClick = _b === void 0 ? function () { return null; } : _b, pageUrlPrefix = props.pageUrlPrefix, _c = props.pageUrlSuffix, pageUrlSuffix = _c === void 0 ? '' : _c;
    var btnText = type || page;
    var isEllipsis = type === PageButtonType.ELLIPSIS;
    var handleClick = function (e) {
        e.preventDefault();
        if (isEllipsis)
            return onEllipsisClick();
        if (!page)
            return false;
        return onPageChange(page);
    };
    return (react_1.default.createElement(Link, { className: (0, classnames_1.default)('page-button', { active: isActive, ellipsis: isEllipsis }), href: !isEllipsis && page ? "".concat(pageUrlPrefix, "/").concat(page).concat(pageUrlSuffix) : undefined, onClick: handleClick }, children !== null && children !== void 0 ? children : btnText));
};
exports.PageButton = PageButton;
var Link = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 3px;\n  display: inline-block;\n  margin: 2px;\n  padding: 7px 14px;\n  text-decoration: none;\n  user-select: none;\n  background-color: rgb(215, 215, 215);\n  color: rgb(136, 136, 136);\n  text-transform: capitalize;\n\n  &:not(.ellipsis):not(.active) {\n    cursor: pointer;\n  }\n\n  &.active,\n  &:hover {\n    background-color: rgb(136, 136, 136);\n    color: rgb(255, 255, 255);\n    text-decoration: none;\n  }\n"], ["\n  border-radius: 3px;\n  display: inline-block;\n  margin: 2px;\n  padding: 7px 14px;\n  text-decoration: none;\n  user-select: none;\n  background-color: rgb(215, 215, 215);\n  color: rgb(136, 136, 136);\n  text-transform: capitalize;\n\n  &:not(.ellipsis):not(.active) {\n    cursor: pointer;\n  }\n\n  &.active,\n  &:hover {\n    background-color: rgb(136, 136, 136);\n    color: rgb(255, 255, 255);\n    text-decoration: none;\n  }\n"])));
exports.default = exports.PageButton;
var templateObject_1;
